













































import ChatActions from '@getaccept/lib-shared/src/chat/components/ChatActions.vue';
import type { ChatComment } from '@getaccept/lib-shared/src/chat/types/chat-comment';
import type { SigningTheme } from '@getaccept/lib-shared/src/signing-theme/types/theme';
import ChatFab from '@getaccept/lib-shared/src/chat/components/ChatFab.vue';
import type { SigningPageUser } from '@getaccept/lib-shared/src/types/signing-page-user';
import type { SigningPageRecipient } from '@getaccept/lib-shared/src/types/signing-page-recipient';
import type { EmojiIndex } from 'emoji-mart-vue-fast';
import { EmojiHelper } from '@getaccept/lib-shared/src/emoji/helpers/emoji.helper';
import type { PropType } from '@vue/composition-api';
import { onMounted, ref, defineComponent } from '@vue/composition-api';
import ChatWindow from './ChatWindow.vue';
import ChatHeader from './ChatHeader.vue';
import ChatContent from './ChatContent.vue';
import ChatSystemMessage from './ChatSystemMessage.vue';

export default defineComponent({
  components: {
    ChatFab,
    ChatWindow,
    ChatActions,
    ChatHeader,
    ChatContent,
    ChatSystemMessage,
  },
  props: {
    recipientId: {
      type: String,
      required: true,
    },
    sender: {
      type: Object as PropType<SigningPageUser>,
      required: true,
    },
    comments: {
      type: Array as PropType<ChatComment[]>,
      required: true,
    },
    recipients: {
      type: Array as PropType<SigningPageRecipient[]>,
      required: true,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    newCommentsCount: {
      type: Number,
      required: true,
    },
    theme: {
      type: Object as PropType<SigningTheme>,
      required: false,
      default: undefined,
    },
    systemMessageOpen: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const emojisEnabled = ref(true);
    const emojiIndex = ref<EmojiIndex>(null);

    const handleSystemMessageClose = () => {
      emit('closeSystemMessage');
    };

    const toggle = () => {
      emit('toggleChat', !props.isOpen);
    };

    const handleSend = (text: string) => {
      emit('send', text);
    };

    onMounted(async () => {
      emojiIndex.value = await EmojiHelper.emojiIndex();
    });

    return {
      emojisEnabled,
      emojiIndex,
      handleSystemMessageClose,
      toggle,
      handleSend,
    };
  },
});
